import { AppState } from "../AppState"
import UserState from "./UserState"
import {GetSSOToken} from "../storage/AuthToken";
import { GetSelectedPortal, GetSelectedAssignedClinic } from "./SelectedCompany/CompanySelectionDrivenSelectors"

export function BuildUserState(state?: AppState): UserState {
  return {
    selectedPortal: GetSelectedPortal(state) ?? undefined,
    selectedCompany: GetSelectedAssignedClinic(state) ?? undefined,
    ssoToken: GetSSOToken()
  }
}
